import * as React from 'react';
import { Rating, Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { ReviewsValidations } from 'utils/domain-specifics/reviews/validation';
import * as styles from './overall-rating-block.styles';
import { secondRow } from './overall-rating-block.styles';

export type OverallRatingBlockProps = {
  numberOfRatings: number;
  ratingValue: number;
} & React.HTMLAttributes<HTMLElement>;

namespace math {
  export const precision = 1;

  export const round = (value: number) => Math.round(value * 10 ** precision) / 10 ** precision;
}

namespace fmt {
  const locale = 'ru-RU';

  export const ratingValue = Intl.NumberFormat(locale, {
    minimumFractionDigits: math.precision,
    maximumFractionDigits: math.precision,
  });

  export const numberOfRatings = new Intl.PluralRules(locale);

  export const getPluralText = (rule: Intl.LDMLPluralRule) => {
    return rule === 'one' ? 'оценки' : 'оценок';
  };
}

export const OverallRatingBlock: React.FC<OverallRatingBlockProps> = ({
  ratingValue,
  numberOfRatings,
  className = '',
  ...htmlProps
}) => {
  const { t } = useTranslation();
  return (
    <div className={className} {...htmlProps}>
      <div className={styles.firstRow}>
        {ReviewsValidations.isRatingValueValid(ratingValue) ? (
          <>
            <div data-testid="rating-full-title-pdp">
              <Typography variant="h1" color="text-primary">
                {fmt.ratingValue.format(ratingValue)}
              </Typography>
            </div>
            <div className={styles.ratingWrapper} data-testid="rating-stars-pdp">
              <Rating value={ratingValue} color="text-primary" />
            </div>
          </>
        ) : null}
      </div>
      {ReviewsValidations.isNumberOfRatingsValid(numberOfRatings) ? (
        <div className={secondRow} data-testid="rating-subtitle-pdp">
          <Typography variant="s" size="body_long" color="text-primary">
            {t('reviews.review.based-on')} {numberOfRatings}&nbsp;
            {t('reviews.review.review-count.count', { count: Number(numberOfRatings) })}
          </Typography>
        </div>
      ) : null}
    </div>
  );
};
